import { useState } from "react";
import { Sidebar, MobileSidebar } from "@/components/Sidebar";
import { GlobalHeader } from "@/components/GlobalHeader";

interface LayoutProps {
    children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

    return (
        <div className="flex h-[100dvh] md:h-screen bg-background overflow-hidden">
            {/* Desktop Sidebar */}
            <Sidebar />

            {/* Mobile Sidebar (slide-out drawer) */}
            <MobileSidebar open={mobileNavOpen} onOpenChange={setMobileNavOpen} />

            {/* Main Content Area */}
            <main className="flex-1 overflow-auto w-full flex flex-col">
                <GlobalHeader onOpenMobileNav={() => setMobileNavOpen(true)} />
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8 flex-1">
                    {children}
                </div>
            </main>
        </div>
    );
}
